import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import SearchableDropdown from "../../../../Core/Fields/Floating/SearchableDropdown";
import GetIcon from "../../../../utils/Icon";
import { usePaymentTermDetailsListMutation } from "../../../../store/api/itemapi";
const TableTab1 = ({
  setselected_payment_term_data,
  list_payment_term_data,
  list_due_date_based_on,
  po_status,
}) => {

  // const createNewRow = () => ({
  //   payment_term: "",
  //   description: "",
  //   due_date_based_on: "",
  //   invoice_portion: "",
  //   credit_days: "",
  // });
  const { value: rows = [], setValue = () => {} } = setselected_payment_term_data || {};
  const tableRef = useRef();
const dropdownRef = useRef(null);
const dropdownRef1 = useRef(null);
  const [rowsPerPage] = useState(10);
 // For "item_tax" dropdown
const [offset, setOffset] = useState(0);
const [search_input, setsearch_input] = useState("");

// For "description" dropdown
const [offset1, setOffset1] = useState(0);
const [search_input1, setsearch_input1] = useState("");

// Pagination control (optional but required if used)
const [hasMore, setHasMore] = useState(true);            // for item_tax
const [hasMoreCategory, setHasMoreCategory] = useState(true); // for description

  const [payment_term_list, setpayment_term_list] = useState([]);
  const [due_date_based_on, setdue_date_based_on] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  // const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [search_input, setsearch_input] = useState("");
const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
const [showDropdown, setShowDropdown] = useState({ rowIndex: null, field: null });
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };
const deepClone = (obj) => JSON.parse(JSON.stringify(obj));




  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

 const createNewRow = () => ({
  payment_term: "",
  description: "",
  due_date_based_on: "",
  invoice_portion: "",
  credit_days: "",
});


const updateRow = async (index, field, value, skipExtraUpdate = false) => {
  const clonedRows = JSON.parse(JSON.stringify(rows || []));
  const currentRow = clonedRows[index] || {};

  // Update field directly
  currentRow[field] = value;
  clonedRows[index] = currentRow;
  setValue(clonedRows);

  // Fetch and autofill when payment_term changes
  if (field === "payment_term" && !skipExtraUpdate && value) {
    try {
      const details = await fetchPaymentTermDetails(value);
      if (details) {
        const freshRows = JSON.parse(JSON.stringify(clonedRows));
        const updatedRow = freshRows[index] || {};

        updatedRow.description = details.description || "";
        updatedRow.due_date_based_on = details.due_date_based_on || "";
        updatedRow.invoice_portion = details.invoice_portion || "";
        updatedRow.credit_days = details.credit_days || "";

        freshRows[index] = updatedRow;
        setValue(freshRows);
      }
    } catch (error) {
      console.error("Error fetching payment term details:", error);
    }
  }
};










   const [PaymentTermDetailsApi] = usePaymentTermDetailsListMutation();

const fetchPaymentTermDetails = async (name) => {
  try {
    const response = await PaymentTermDetailsApi(name).unwrap(); // Use `.unwrap()` to get the raw response
    return response?.data || null;
  } catch (err) {
    console.error("Error fetching payment term details:", err);
    return null;
  }
};


  const getPaymentTerm = async (newOffset = 0, searchText = "") => {
    const res = await list_payment_term_data({
      start: newOffset,
      search_input: searchText,
    });
    const products = res?.data?.data || [];
    // console.log('pt list:',products)
    if (newOffset === 0) {
      setpayment_term_list(products);
    } else {
      setpayment_term_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 20);
  };
const geDueDateBasedOnPaymentTerm = async (newOffset = 0, searchText = "") => {
  const staticDueDateOptions = [
    { name: "Day(s) after invoice date" },
    { name: "Day(s) after the end of the invoice month" },
    { name: "Month(s) after the end of the invoice month" },
  ];

  const products = staticDueDateOptions || [];
  // console.log("d list:", products);

  if (newOffset === 0) {
    setdue_date_based_on(products);
  } else {
    setdue_date_based_on(prev => [...prev, ...products]);
  }

  setHasMore(products.length === 20); // fake pagination check
};



  
 

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setValue(newRows); // ✅ update via pageState
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) setCurrentPage(lastPage);
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setValue(updatedRows); // ✅ update via pageState
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    getPaymentTerm(0, "");
    geDueDateBasedOnPaymentTerm(0, "");
  }, []);



  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);



  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "Action",
              "S.No",
              "Payment Term",
              "Description",
              "Invoice Portion (%)",
              "Due Date Based On",
              "Credit Days",
              <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
            ].map((title, i) => {
              const isIcon = typeof title !== "string";
              const defaultWidths = {
                Action: "54px",
                "S.No": "54px",
                "Payment Term": "202px",
                "Description": "202px",
                "Invoice Portion (%)": "202px",
                "Due Date Based On": "302px",
                "Credit Days": "202px",
                Action1: "102px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: "7px",
                    position: "relative",
                    textAlign:
                      title === "Action" ||
                      title === "S.No" ||
                      title === "isIcon"
                        ? "center"
                        : "center",

                    width:
            typeof title === "string" ? defaultWidths[title] || "202px" : "202px",
          minWidth:
            typeof title === "string" ? defaultWidths[title] || "202px" : "202px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{
                        backgroundColor: isAllSelected ? "#270b79" : "",
                        borderColor: isAllSelected ? "#270b79" : "",
                        fontSize: "15px",
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : isIcon ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {title}
          </div>
        ) : (
          title
        )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="p-0" style={{ cursor: "pointer" }}>
                  <p
                    className="m-0"
                    style={{ position: "relative", top: "5px" }}
                  >
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{
                            backgroundColor: "#270b79",
                            fontSize: "15px",
                            borderColor: "#270b79",
                          }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ fontSize: "15px" }}
                        />
                      </span>
                    )}
                  </p>
                </td>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: '0.8rem',textAlign: "center",
                    padding: "0.5rem",
                  }}
                >
                  {globalIndex + 1}
                </td>
  <td className="p-0">
  <SearchableDropdown
    globalIndex={globalIndex}
    field="payment_term"
    value={row.payment_term || ""}
    onChange={(val) => updateRow(globalIndex, "payment_term", val)}
    onSearch={(text) => getPaymentTerm(0, text)}
    dropdownData={payment_term_list}
    placeholder="Select Payment Term"
    focusedCell={focusedCell}
    setFocusedCell={setFocusedCell}
    showDropdown={showDropdown}
    setShowDropdown={setShowDropdown}
    dropdownRef={dropdownRef}
    setOffset={setOffset}
    offset={offset}
    search_input={search_input}
    hasMore={hasMore}
    getData={getPaymentTerm}
    createNewUrl="/master/payment-term/create-payment-term"
    createNewLabel="+ Create Payment Term"
  />
</td>



 <td className="p-0 d-flex justify-content-center" style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'description' ? '0.3px solid #270b79' : '' 
                    }}
>
                  <input
  onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: "description" })}
  onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
  className="form-control tableinput noborder"
  style={{ fontSize: "0.8rem", textAlign: "center" }}
   value={row.invoice_portion || ""}
  placeholder="Description"
  onChange={(e) =>
    updateRow(globalIndex, "description", e.target.value)
  }
/>

                </td>



               
                <td className="p-0" style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'invoice_portion' ? '0.3px solid #270b79' : '' 
                    }}
>
                  <input
                  placeholder="Invoice Portion (%)"
                    type="text"
                     onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'invoice_portion' })}
                    onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                     value={row.invoice_portion || ""}
                    onChange={(e) =>
                      updateRow(globalIndex, "invoice_portion", e.target.value)
                    }
                  />
                </td>


         <td className="p-0">
 <SearchableDropdown
  globalIndex={globalIndex}
  field="due_date_based_on"
 value={row.due_date_based_on || ""}
  onChange={(val) => updateRow(globalIndex, "due_date_based_on", val)}
  onSearch={(text) => geDueDateBasedOnPaymentTerm(0, text)}
  dropdownData={due_date_based_on}
  placeholder="Select Due Date Based On"
  focusedCell={focusedCell}
  setFocusedCell={setFocusedCell}
  showDropdown={showDropdown}
  setShowDropdown={setShowDropdown}
  dropdownRef={dropdownRef1}
    setOffset={setOffset1}
    offset={offset1}
    search_input={search_input1}
  hasMore={hasMore}
  getData={geDueDateBasedOnPaymentTerm}
/>


</td> 



                <td className="p-0 d-flex justify-content-center" style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'credit_days' ? '0.3px solid #270b79' : '' 
                    }}
>
                  <input
                    type="text"
                    placeholder="Credit Days"
                    onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'credit_days' })}
                    onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem',textAlign: "center" }}
                     value={row.credit_days || ""}
                    onChange={(e) =>
                      updateRow(globalIndex, "credit_days", e.target.value)
                    }
                  />
                </td>

                <td
                  style={{
                    position: "relative",
                    width: "40px",
                  }}
                >
                  <img
                    src="/Maskgroup.png"
                    alt="edit"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "12px",
                      height: "12px",
                      pointerEvents: "none",
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div
        className="d-flex pb-2  justify-content-between align-items-center"
        style={{ marginTop: "12px", marginBottom: "16px" }}
      >
        <div className="d-flex" style={{ gap: "4px" }}>
          {selectedRows.length > 0 && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length == 0 && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{
                backgroundColor: "#F6D593",
                padding: "1px",
                display: "flex",
              }}
            >
              Add Row
            </Button>
          )}
        </div>

        <div
          className={`${
            rows.length < 11 ? "d-none" : "d-flex"
          } align-items-center centerpagination`}
          style={{ gap: "5px" }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
            Showing {indexOfFirstRow + 1} to{" "}
            {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableTab1;
